export default __webpack_public_path__ + "static/media/sunset.05797370.svg";